import { ModalService } from './../../services/app-modal.service';
import { Component, ComponentFactoryResolver, ViewChild, ViewContainerRef, AfterViewInit, OnDestroy, Type, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-modal',
  template: `
    <div *ngIf="isVisible" class="modal-overlay">
      <div class="modal-content">
        <div class="modal-header">
          <button (click)="close()">X</button>
        </div>
        <div #container></div>
        <div class="modal-footer">
          <button (click)="close()">Cancelar</button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  @ViewChild('container', { read: ViewContainerRef }) container!: ViewContainerRef;
  isVisible = false;
  private modalSubscription!: Subscription;

  constructor(
    private modalService: ModalService,
    private resolver: ComponentFactoryResolver,
    private cdr: ChangeDetectorRef  // Injete o ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    // Detecte mudanças para garantir que o ViewChild seja inicializado
    this.cdr.detectChanges();

    // Inscreva-se no serviço de modal depois da inicialização da visualização
    this.modalSubscription = this.modalService.modalComponent.subscribe(component => {
      if (component) {
        this.showModal(component);
      } else {
        this.close();
      }
    });
  }

  showModal(component: Type<any>) {
    if (this.container) {
      this.container.clear();
      const factory = this.resolver.resolveComponentFactory(component);
      this.container.createComponent(factory);
      this.isVisible = true;
    } else {
      console.warn('Container not initialized');
    }
  }

  close() {
    if (this.container) {
      this.container.clear();
    }
    this.isVisible = false;
  }

  ngOnDestroy() {
    if (this.modalSubscription) {
      this.modalSubscription.unsubscribe();
    }
  }
}
